import { post } from "../services";

export const AUTH = {
  userLogin: async (loginDto) => {
    let data = await post(`auth/login`, loginDto);
    return data;
  },
  forgotPwd: async (loginDto) => {
    let data = await post(`auth/forgot-password`, loginDto);

    return data;
  },
  validateOtp: async (loginDto) => {
    let data = await post(`auth/verify-admin-otp`, loginDto);

    return data;
  },
  resetPwd: async (loginDto) => {
    let data = await post(`auth/reset-password`, loginDto);

    return data;
  },
  deleteAccount: async (loginDto) => {
    let data = await post(`api/auth/delete-account`, loginDto);

    return data;
  },
};
